import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import KpiCard from "./kpiCard";
import { CARRIER_COLORS, KPI_MONTH_BORDER_COLOR } from "../constants/graphics";
import { formatNumber } from "../../../helpers/functions/functions";

// Variación porcentual respecto al periodo anterior.
// Sin periodo anterior la variación se reporta como 100%, igual que el resto del dashboard.
export const getVariation = (current, previous) => {
  if (!previous) return current ? 100 : 0;
  return ((current - previous) / previous) * 100;
};

const getCarrierTotal = (month, carrier) =>
  month?.totalServiceProvider?.[carrier]?.solicitados || 0;

// Fila de tarjetas KPI: total anual, total del mes y total del mes por operadora
const KpiCardsRow = ({ annualData, monthIndex, darkMode, loading }) => {
  const currentMonth = annualData.months[monthIndex];
  const previousMonth =
    monthIndex > 0 ? annualData.months[monthIndex - 1] : null;

  const currentMonthTotal = currentMonth?.solicitados || 0;
  const previousMonthTotal = previousMonth?.solicitados || 0;

  const carrierCards = [
    { carrier: "MOVISTAR", label: "SMS Movistar" },
    { carrier: "DIGITEL", label: "SMS Digitel" },
    { carrier: "MOVILNET", label: "SMS Movilnet" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
        alignItems: "stretch",
        width: "100%",
        height: "100%",
        flexWrap: { xs: "wrap", lg: "nowrap" },
      }}
    >
      <KpiCard
        title="SMS Total YTD"
        subtitle="Mensajes enviados en el año en curso"
        value={formatNumber(annualData.total.solicitados)}
        darkMode={darkMode}
        loading={loading}
      />
      <KpiCard
        title="SMS de Mes"
        subtitle="Suma todas las operadora mes actual"
        value={formatNumber(currentMonthTotal)}
        variation={getVariation(currentMonthTotal, previousMonthTotal)}
        showVariation
        borderColor={KPI_MONTH_BORDER_COLOR}
        darkMode={darkMode}
        loading={loading}
      />
      {carrierCards.map(({ carrier, label }) => (
        <KpiCard
          key={carrier}
          title={label}
          subtitle="Mensajes enviados en mes actual"
          value={formatNumber(getCarrierTotal(currentMonth, carrier))}
          variation={getVariation(
            getCarrierTotal(currentMonth, carrier),
            getCarrierTotal(previousMonth, carrier),
          )}
          showVariation
          borderColor={`${CARRIER_COLORS[carrier]}80`}
          darkMode={darkMode}
          loading={loading}
        />
      ))}
    </Box>
  );
};

KpiCardsRow.propTypes = {
  annualData: PropTypes.object.isRequired,
  monthIndex: PropTypes.number.isRequired,
  darkMode: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default KpiCardsRow;
